/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminDeleteCourseOptions, AdminDeleteCourseResponses } from '../../models/AdminDeleteCourse'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Delete Course
 * {@link /admin/course/:course_id}
 */
export function adminDeleteCourse<ThrowOnError extends boolean = true>(options: Options<AdminDeleteCourseOptions, ThrowOnError>): Promise<UnwrappedResult<AdminDeleteCourseResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'DELETE', url: '/admin/course/{course_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminDeleteCourseResponses, ThrowOnError>>
}
